import { useEffect } from 'react';
import useToast from './toast/useToast';

/**
 * Listens for `glacier:firestore-error` window events (fired by
 * `src/lib/firebase-health.js`) and surfaces each one as a toast. Mounted
 * once at app root, inside <ToastProvider>.
 *
 * The error module is responsible for dedupe + rate limiting; this listener
 * just translates events to toasts.
 */
export function FirebaseHealthListener() {
  const { showToast } = useToast();

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const handler = (e) => {
      const detail = e && e.detail ? e.detail : null;
      const msg = (detail && detail.message) || 'Database error';
      showToast(msg, { duration: 6000 });
    };
    window.addEventListener('glacier:firestore-error', handler);
    return () => window.removeEventListener('glacier:firestore-error', handler);
  }, [showToast]);

  return null;
}

export default FirebaseHealthListener;
